import { LoadingOutlined } from '@ant-design/icons';
import { FC } from 'react';
import UploadIcon from '../../assets/images/catalogue/uploadIcon';

interface IButton {
  loading?: boolean;
}

const UploadButton: FC<IButton> = ({ loading }: IButton) => {
  return (
    <div className="containerUpload">
      {!loading && <div className="text-center">Arrastra hasta aqui</div>}
      {loading ? (
        <LoadingOutlined
          size={500}
          style={{ fontSize: '70px', margin: 'auto !important', display: 'block' }}
          className="m-auto block"
        />
      ) : (
        <UploadIcon className="m-auto block" style={{ marginTop: '60px' }} />
      )}
    </div>
  );
};
export default UploadButton;
